import React from 'react';
import WeatherIcon from '../../Basic/WeatherIconButton/WeatherIconButton.mjs';
import Heading from '../../Typography/Heading/Heading.mjs';
import { StyledCurrentWeather } from './CurrentWeather.styles.mjs';

const CurrentWeather = ({ iconCode, size, temperature, href, onClick }) => {
    return (React.createElement(StyledCurrentWeather, { href: href, "data-testid": "current-weather", onClick: onClick },
        React.createElement(WeatherIcon, { size: size, iconCode: iconCode }),
        !isNaN(temperature) && React.createElement(Heading, { tag: "h6" }, `${temperature}°`)));
};

export { CurrentWeather as default };
//# sourceMappingURL=CurrentWeather.mjs.map
